<div class="input">
    <div class="position-wrapper">
        <img src="/content/icons/Magnifier.svg" class="input-icon-magnifier">
        <input autocorrect="off" autocapitalize="off" spellcheck="off" [placeholder]="'Enter a location' | translate" [formControl]="locationControl" (blur)="onBlur()" #searchElement>
    </div>
</div>
